<div class="card-body table-responsive">
    <div class="row d-flex justify-content-between align-items-center">
        <div class="col-sm-12 col-md-3 col-lg-auto">
            <div class="input-group">
                <span class="input-group-text bg-primary" id="search" ngbTooltip="Filter by From date." placement="top"
                    container="body">
                    <i class="bx bx-calendar-week"></i>
                </span>
                <input type="date" class="form-control border-start-0" id="search" placeholder="From date..."
                    autocomplete="off" [(ngModel)]="fromDate">
            </div>
        </div>
        <div class="col-sm-12 col-md-3 col-lg-auto ps-1">
            <div class="input-group">
                <span class="input-group-text bg-primary" id="search" ngbTooltip="Filter by To date." placement="top"
                    container="body">
                    <i class="bx bx-calendar-week"></i>
                </span>
                <input type="date" class="form-control border-start-0" id="search" placeholder="To date..."
                    autocomplete="off" [(ngModel)]="toDate" [min]="fromDate">
            </div>
        </div>
        <div class="col-sm-12 col-md-5 col-lg-2 ps-1">
            <div class="input-group">
                <span class="input-group-text bg-primary" id="search" ngbTooltip="Filter by Status." placement="top"
                    container="body">
                    <i class="bx bx-filter"></i>
                </span>
                <select class="form-select" autocomplete="off" id="status" [(ngModel)]="status" required>
                    <option hidden value="" disabled selected>Choose...
                    </option>
                    <option *ngFor="let status of statuses;let i=index" [ngValue]="status">
                        {{status}}
                    </option>
                </select>
            </div>
        </div>
        <div class="col-sm-12 col-md-3 col-lg-2 me-auto ps-1">
            <div class="input-group">
                <button type="button" placement="top" container="body" (click)="onStatusChange()"
                    class=" btn btn-secondary btn-sm " ngbTooltip="Fetch Records.">
                    <i class="bx bx-search-alt-2 ri-lg align-middle me-0"></i>
                </button>
            </div>
        </div>
    </div>
    <table class="table" id="table">
        <thead id="table-thead">
            <tr class="bg-light">
                <th scope="col" width="70">#</th>
                <th scope="col" width="200">Employee</th>
                <th scope="col" width="150">From</th>
                <th scope="col" width="150">To</th>
                <th scope="col" width="150">Duration</th>
                <th scope="col" width="300">Reason</th>
                <th scope="col" width="300">Comment</th>
                <th scope="col" style="text-align: center;" *ngIf="tempStatus!=='REVOKED' && tempStatus!=='REJECTED'">
                    Actions</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let approval of approvals; let i=index">
                <td>{{i+1}}.</td>
                <td>{{approval.appliedBy?.name}}</td>
                <td>{{approval.appliedFrom  | date:'MMM dd, yyyy'}}</td>
                <td>{{approval.appliedTo  | date:'MMM dd, yyyy'}}</td>
                <td>{{approval.partial?'Half Day':'Full Day'}}</td>
                <td>{{approval.reason}}</td>
                <td class="p-0" *ngIf="approval.status==='APPLIED' || approval.status==='APPROVED'">
                    <div class="col-md-6 col-5 col-lg-10">
                        <input type="text" class="form-control form-control-sm" [(ngModel)]="approval.comments"
                            placeholder="Enter comment">
                    </div>
                </td>
                <td *ngIf="approval.status==='REJECTED' || approval.status==='REVOKED'">
                    <div>{{approval.comments}}</div>
                </td>
                <td class="actions p-1" *ngIf="tempStatus!=='REVOKED' && tempStatus!=='REJECTED'">
                    <button type="button" class="btn btn-outline-success approve-btn btn-sm" #inProgress
                        [ngClass]="{'no-event':inProgress?.value=='true'}" *ngIf="approval.status !== 'APPROVED'"
                        [ngClass]="{'not-allowed':!privilege.canEdit}"
                        [ngbTooltip]="!privilege.canEdit? 'You need permissions for this action. Required permission(s): setup.leave.edit' : ''"
                        (click)="approveLeave(approval,inProgress,'APPROVED',i)">
                        <ng-container *ngIf="inProgress?.value=='true'">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        </ng-container>
                        <ng-container *ngIf="inProgress?.value!='true'">
                            <i class="bx bx-check bx-btn "></i>Approve
                        </ng-container>
                    </button>
                    <button type="button" class="btn btn-outline-danger approve-btn btn-sm" #rejectInProgress
                        [ngClass]="{'no-event':rejectInProgress?.value=='true'}" value="REJECTED"
                        [ngClass]="{'not-allowed':!privilege.canEdit}"
                        [ngbTooltip]="!privilege.canEdit? 'You need permissions for this action. Required permission(s): setup.leave.edit' : ''"
                        *ngIf="approval.status !== 'REJECTED'" [(ngModel)]="approval.status"
                        (click)="approveLeave(approval,rejectInProgress, approval.status=='APPROVED'?'REVOKED':'REJECTED',i)">
                        <ng-container *ngIf="rejectInProgress?.value=='true'">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        </ng-container>
                        <ng-container *ngIf="rejectInProgress?.value!='true'">
                            <i class="bx bx-x bx-btn"></i>{{approval.status=='APPROVED'?'Revoke':'Reject'}}
                        </ng-container>
                    </button>
                </td>
            </tr>
            <tr class="no-data">
                <ng-container *ngIf="isLoading; else noDataTemplate">
                    <td colspan="8">Fetching data, please wait...</td>
                </ng-container>
                <ng-template #noDataTemplate>
                    <ng-container *ngIf="approvals && approvals.length < 1; else noSearchResults">
                        <td colspan="8">No leaves were found.</td>
                    </ng-container>
                    <ng-template #noSearchResults>
                        <td colspan="8"
                            *ngIf="searchKeyword && (approvals | search : 'name' : searchKeyword).length == 0">
                            No leaves were found for the search results.
                        </td>
                    </ng-template>
                </ng-template>
            </tr>
        </tbody>
    </table>
</div>
